import { render, staticRenderFns } from "./AllowancesPlanDetailsAdd.vue?vue&type=template&id=a621e506&scoped=true&"
import script from "./AllowancesPlanDetailsAdd.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a621e506",
  null
  
)

export default component.exports